import { render, staticRenderFns } from "./balance.vue?vue&type=template&id=77f1aa60&"
import script from "./balance.vue?vue&type=script&lang=js&"
export * from "./balance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77f1aa60')) {
      api.createRecord('77f1aa60', component.options)
    } else {
      api.reload('77f1aa60', component.options)
    }
    module.hot.accept("./balance.vue?vue&type=template&id=77f1aa60&", function () {
      api.rerender('77f1aa60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/keystore/balance.vue"
export default component.exports